import React, {Component} from 'react';
import './AuthCallback.css';
import {connect} from 'react-redux';
import handleError from '../handleError';
import Loading from '../widgets/Loading';
import jsonFetch from '../jsonFetch';
import {push} from 'react-router-redux';
import {actions} from '../session.state';

/**
 * Show a splash/loading screen for the user whilst waiting for authentication token from Microsoft.
 */
class AuthCallback extends Component {
	componentDidMount() {
		const { getToken, handleError, sessionClear, redirect, redirectLoggedout, sessionSet } = this.props;
		getToken()
				.then(({ accessToken }) => jsonFetch(`${process.env.REACT_APP_API}/auth/callback?token=${accessToken}`))
				.then(json => {
					// XSS is low risk here (all internal staff data) so session storage is OK for our use case
					localStorage.setItem('email', json.email);
					localStorage.setItem('token', json.token);
					redirect();

					return json.email;
				})
				.then(json => sessionSet(json))
				.catch(e => {
					sessionClear();
					localStorage.clear();
					redirectLoggedout();
					handleError(e);
				});
	};
	
	render() {
		return (
			<div className="AuthCallback">
				<div>
					<Loading/>
					<p>Waiting for auth token from Microsoft...</p>
				</div>
			</div>
		);
	}
}


const ConnectedAuthCallback = connect(
	() => ({}),
	dispatch => ({
		handleError: handleError(dispatch, true),
		redirect: () => dispatch(push('/')),
		sessionSet: data => dispatch(actions.sessionSet(data)),
		sessionClear: () => dispatch(actions.sessionClear()),
		redirectLoggedout: () => dispatch(push('/loggedout'))
	})
)(AuthCallback);

export default ConnectedAuthCallback;


// WEBPACK FOOTER //
// ./src/chrome/AuthCallback.js